import EFOcats_error_info from '../../../core/v2/efocats_error_info';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang';
import efocats_validate_core from '../../../core/v2/validate/efocats_validate_core';

export default class EFOcats_iwatani_validate_space extends efocats_validate_core {
  validate(checkData) {
    const pattern = new RegExp(/[\n\t\s]/);

    if (checkData.val().match(pattern)) {
      return new EFOcats_error_info('error', EFOcats_import_lang.getValue('includespace'), '', EFOcats_import_lang.getValue('includespace'));
    }

    return new EFOcats_error_info('success', '', '', '');
  }
}
